module.exports = __webpack_public_path__ + "static/media/dropdown-triangle.46ef84ca.svg";